import React from 'react';
import {useTranslation} from "react-i18next";

export default function EmptyInfo() {
  const {t} = useTranslation()

  return (
    <div className={'info__empty-wrapper'}>
      <div className={'info__empty'}>
        <span className={'info__empty-text'}>{t('info.empty_text')}</span>
      </div>
    </div>
  )
}
